import { INQUIRY_STATUS_LABELS, type InquiryStatus } from '@kontor/shared';

export function StatusBadge({ status }: { status: InquiryStatus }) {
  return <span className={`badge badge--${status}`}>{INQUIRY_STATUS_LABELS[status] ?? status}</span>;
}
